import { Checkbox } from "@fluentui/react";
import React from "react";
import {
  addElement,
  setOnPremiseState,
} from "../../../actions/CreateSiteActions/createSiteActions";
import { connect } from "react-redux";
import {
  ADD_CONFIDENTIALITY,
  ADD_ONLINE_LOCATION,
  SET_ORDER_CREATED,
  ADD_QUOTA,
  ADD_LOCATION,
} from "../../../actions/types";
import DisplayMessage from "../DisplayMessage";

import { getQuotas, getLocations } from "../../../actions/fetchActions";
import { LocationType } from "../../../GlobalConst/globalEnums";

class ConfidentialityLevels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  handleSelection(e) {
    let value = e.target.id;
    let locationType;
    this.props.sendElement(ADD_CONFIDENTIALITY, { key: value, value: value });
    this.props.sendElement(SET_ORDER_CREATED, false);
    // if(value === ConfidentialityLevel.strictlyConfidential_display)
    // {
    //     locationType = LocationType.onPremise;
    //     this.props.setOnpremise(true);
    //     this.props.sendElement(ADD_ONLINE_LOCATION,false);
    //     this.props.sendElement(ADD_EXTERNALCOLLABORATION, false);
    //     // this.props.getLocations(LocationType.onPremise);
    //     // this.props.getQuotas(LocationType.onPremise)
    // }
    // else
    // {
    locationType = LocationType.online;
    this.props.setOnpremise(false);
    this.props.sendElement(ADD_ONLINE_LOCATION, true);
    // this.props.getLocations(LocationType.online);
    // this.props.getQuotas(LocationType.online)
    //  }

    const defaultQuota = this.props.quotas.filter(
      (x) => x.location.locationType === locationType && x.default && x.active
    )[0];
    this.props.sendElement(ADD_QUOTA, defaultQuota.quotaSize);

    const defaultLocation = this.props.locations.filter(
      (x) => x.locationType === locationType
    )[0];
    this.props.sendElement(ADD_LOCATION, defaultLocation);

    this.props.sendElement(ADD_CONFIDENTIALITY, value);
  }

  render() {
    const choices = this.props.confidentialityLevels.map((item) => (
      <div
        key={item.key}
        style={{ marginBottom: "4px" }}
        className="cLevel-checkbox">
        <Checkbox
          id={item.value}
          label={item.value}
          disabled={this.props.pgEmployee}
          checked={item.value === this.props.confidentiality}
          onChange={this.handleSelection.bind(this)}
        />
      </div>
    ));

    const error = this.props.possibleWarning && !this.props.confidentiality && (
      <div className="errorMessage">Please select an option</div>
    );

    return (
      <div className="confidentiality">
        {choices}
        <DisplayMessage error={this.state.error} />
        {error}
      </div>
    );
  }
}
const mapActionsToProps = {
  sendElement: addElement,
  setOnpremise: setOnPremiseState,
  getLocations: getLocations,
  getQuotas: getQuotas,
};

const mapStateToProps = (state) => ({
  confidentiality: state.newSite.Confidentiality,
  possibleWarning: state.wizard.nextStepRequested,
  onlineLocation: state.newSite.OnlineLocation,
  confidentialityLevels: state.app.siteConfidentialityLevels,
  quotas: state.app.siteQuotas,
  locations: state.app.siteLocations,
});

export default connect(
  mapStateToProps,
  mapActionsToProps
)(ConfidentialityLevels);



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/ConfidentialityLevels.js